<template>
  <div>
    <el-card>
      <div style="display: flex">
        <div style="width: 50%">
          <el-row>
            <el-col v-if="isShow">
              <el-button :disabled="editFlag" size="small" type="warning" @click="openEdit"
                >编辑
              </el-button>
            </el-col>
            <el-col v-else>
              <el-button size="small" type="primary" @click="submit()">保存</el-button>
              <el-button size="small" @click="closeEdit">取消</el-button>
            </el-col>
          </el-row>
          <el-form ref="openRef" :disabled="isShow" :model="prop" :rules="PropRules" label-width="100px" size="small">
            <el-row>
              <el-col :md="12" align="left">
                <el-form-item
                  :label="(prop.smpl_type === 1 ? '新款片数' : prop.smpl_type === 2 ? '老款片数' : '修改款片数') + '：'"
                  prop="rfid_open_phr"
                >
                  <el-input v-model="prop.rfid_open_phr" maxlength="9" show-word-limit @input="openPhrChange">
                    <template slot="append">片</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="12">
                <el-form-item label="裁片数量：" prop="rfid_cut_num">
                  <el-input v-model="prop.rfid_cut_num" maxlength="9" show-word-limit @input="cutNumChange">
                    <template slot="append">片</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="12">
                <el-form-item label="开版总片数：" prop="rfid_open_sum_phr">
                  <el-input v-model="prop.rfid_open_sum_phr" maxlength="9" show-word-limit @input="cutNumChange2">
                    <template slot="append">片</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="12">
                <el-form-item label="填卡人：" prop="card_user_id">
                  <el-select v-model="prop.card_user_id" filterable placeholder="请选择">
                    <el-option v-for="item in stffList" :key="item.user_id" :label="item.stff_name" :value="item.user_id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <el-form :disabled="isShow" label="right" label-width="100px">
            <el-row>
              <el-form-item label="制作人：" prop="stff_id" size="small">
                <el-select
                  v-model="prop.stff_id"
                  :disabled="!['徐礼明', '盖新', 'Admin'].includes($cookies.get('userInfo').stff_name)"
                  filterable
                  placeholder="请选择"
                  @change="
                    val => {
                      const find = processList.find(item => item.value === val).o;
                      prop.user_id = find.user_id;
                      prop.stff_name = find.stff_name;
                    }
                  "
                >
                  <el-option v-for="item in processList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="岗位：" size="small">
                <el-input :value="prop.user_jobs" disabled show-word-limit></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="难度系数：" size="small">
                <el-input :value="prop.price" disabled show-word-limit></el-input>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { spocAPI } from '@api/modules/spoc';
import { post } from '@api/request';
import helper from '@assets/js/helper';

export default {
  data() {
    return {
      // originalData: this.prop,
      isShow: true,
      PropRules: {
        rfid_open_phr: [
          { required: true, message: '请填写开版用量', trigger: 'blur' },
          { pattern: /^[0-9]*$/, message: '只能输入零和正整数!' }
        ],
        rfid_cut_num: [
          { required: true, message: '请填写裁片数量', trigger: 'blur' },
          { pattern: /^[0-9]*$/, message: '只能输入零和正整数!' }
        ]
      }
    };
  },
  methods: {
    submit() {
      this.$refs['openRef'].validate(valid => {
        if (valid) {
          this.$confirm('此操作将保存修改, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(res => {
              let editBody = {};
              editBody = JSON.parse(JSON.stringify(this.prop));

              if (!editBody.rfid_id) {
                editBody.rfid_id = this.rfid_Info.rfid_id;
                editBody.user_id = this.rfid_Info.user_id;
                editBody.stff_id = this.rfid_Info.stff_id;
                editBody.card_user_id = this.rfid_Info.card_user_id;
              }
              post(spocAPI.edit_open, editBody)
                .then(res => {
                  if (res.data.code == 0) {
                    this.$emit('copyOpen', this.prop);
                    this.$message.success(res.data.msg);
                  } else {
                    this.$message.error(res.data.msg);
                  }
                  this.$emit('del');
                })
                .catch(res => {
                  this.$message.error(res.data.msg);
                });

              this.isShow = true;
            })
            .catch(res => {});
        }
      });
    },
    openEdit() {
      this.$emit('num');
      this.isShow = false;
    },
    closeEdit() {
      this.$confirm('此操作将取消修改, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(res => {
          this.isShow = true;
          this.$message.info('已取消修改');
          this.$emit('del');
          this.prop.rfid_open_phr = this.originalOpen.rfid_open_phr;
          this.prop.rfid_cut_num = this.originalOpen.rfid_cut_num;
          this.prop.rfid_open_sum_phr = this.originalOpen.rfid_open_sum_phr;
        })
        .catch(res => {});
    },

    openPhrChange(val) {
      val = this.keepNum99(val);
      this.$emit('openPhrChange', val);
    },
    cutNumChange(val) {
      val = this.keepNum99(val);
      this.$emit('cutNumChange', val);
    },
    cutNumChange2(val) {
      val = this.keepNum99(val);
      this.$emit('cutNumChange2', val);
    },
    keepNum99(val) {
      let keepTNum = Number(helper.keepTNum1(val));
      if (keepTNum > 999) {
        this.$message.warning('输入范围0～999超出最大限度');
        return 999;
      } else {
        return keepTNum;
      }
    }
  },
  props: {
    prop: {
      type: Object
    },
    rfid_perm_status: Number,
    rfid_Info: Object,
    editFlag: Boolean,
    mainIsShow: Boolean,
    originalOpen: Object,
    stffList: Array,
    processList: Array
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
</style>
